export default __webpack_public_path__ + "static/media/01Indore.8ffee008.jpg";